var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#00A478"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#009393"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2555 12.8044C14.3192 12.8044 16.0439 12.4555 16.4654 11.9893C16.1075 11.5939 14.813 11.2825 13.169 11.1973V12.1822C12.8747 12.1975 12.5687 12.205 12.2552 12.205C11.9417 12.205 11.6357 12.1975 11.3408 12.1822V11.1973C9.69737 11.2825 8.40227 11.5939 8.04437 11.9893C8.46647 12.4555 10.1915 12.8044 12.2552 12.8044H12.2555ZM15.9221 8.16851V9.52481H13.169V10.4653C15.1028 10.5658 16.5539 10.9792 16.5647 11.4739V12.5053C16.5539 13 15.1028 13.4125 13.169 13.5133V15.8215H11.3411V13.5133C9.40727 13.4128 7.95677 13 7.94597 12.5053V11.4739C7.95677 10.9792 9.40727 10.5658 11.3411 10.4653V9.52481H8.58797V8.16851H15.9224H15.9221ZM7.50527 6.01001H17.1701C17.4011 6.01001 17.6138 6.13151 17.729 6.32891L20.5445 11.1637C20.6903 11.4145 20.6471 11.731 20.4389 11.9341L12.6887 19.4995C12.4373 19.7446 12.0335 19.7446 11.7827 19.4995L4.04207 11.9443C3.82937 11.7361 3.78917 11.4106 3.94607 11.1586L6.95597 6.31391C7.07327 6.12551 7.28147 6.01031 7.50557 6.01031L7.50527 6.01001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.c1a2ae46a639543911ea1b846da86686.svg";
export { ForwardRef as ReactComponent };